// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// A genotype of an animal
// Example: "CH"

export const genotypeExtMinLength = 1;
export const genotypeExtMaxLength = 2;

export const GenotypeExtSchema = t.refinement(t.string, n => n.length >= genotypeExtMinLength && n.length <= genotypeExtMaxLength, 'GenotypeExt');

export type GenotypeExt = string;
